import React from 'react';
import './Footer.css';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

function Footer() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { t, i18n } = useTranslation();

  const renderLinks = (title, links) => (
    <div className="footer-col">
      <h4>{t(title)}</h4>
      <ul>
        {links.map((link, index) => (
          <li key={index}><a href={link.url}>{t(link.label)}</a></li>
        ))}
      </ul>
    </div>
  );

  const companyLinks = [
    { label: 'A Propos', url: '/about_us' },
    { label: 'Secteur d\'Intervention', url: '/secteurs' },
    { label: 'Champ d\'Activités', url: '/control' },
    { label: 'Formation', url: '/formation' },
    { label: 'Qualité', url: '/qualite' },
    { label: 'Contact', url: '/contact' },
  ];

  const servicesLinks = [
    { label: 'Contrôle Non Destructif (CND)', url: '/controlCND' },
    { label: 'Réception et Suivi de Construction (RSC)', url: '/controlRSC' },
    { label: 'Contrôle Réglementaire de Sécurité (CRS)', url: '/controlCRS' },
  ];

  return (
    <div className="footer">
      <div className="containerf">
        <div className={`rowf ${isMobile ? 'mobile' : ''}`}>
          <div className="footer-col2">
            <div className="site-logo">
              <a href="/">
                <img className="logo-nav2" src="images/PIfooter.png" alt="" title="Professional inspectors" />
              </a>
            </div>
          </div>
          {renderLinks('PROFESSIONAL INSPECTORS', companyLinks)}
          {renderLinks('Domaine d\'Application' , servicesLinks)}
          <div className="footer-col">
            <h4>{t('contact')}</h4>
            <ul>
              <li>{t('amine.sellami@professional-inspectors.com')}</li>
              <li>{t('mohamed.sellami@professional-inspectors.com')}</li>
              <li>{t(' 11 Rue Ali Ben Khelifa 1013 Menzah 9 - TUNIS')}</li>
              <li>{t('Tél. : (+216) 71 889 071 / (+216) 29 370 529')}</li>
              <li>PI Sfax: {t('Route de Gabès Km 3, 3000 Sfax')}</li>
              <li>{t('Tél.: (+216) 74 453 013 / (+216) 29 370 529')}</li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
